export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-300/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-spy-line text-background-50 text-sm"></i>
              </div>
              <span className="font-heading text-lg text-foreground-950">暗网吃瓜</span>
            </div>
            <p className="text-xs text-foreground-500 leading-relaxed">
              暗网吃瓜是国内领先的黑料查询与爆料聚合平台，覆盖娱乐圈、网红圈、科技圈、商业圈等多个领域。每日更新最新爆料，提供精准的黑料搜索与吃瓜资源检索服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-800 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">首页</a>
              <a href="#index" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">热门专题</a>
              <a href="#cards" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">今日焦点</a>
              <a href="#ranking" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">热搜榜单</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-800 mb-4">服务支持</h4>
            <div className="flex flex-col gap-2">
              <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
              <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">爆料投稿</a>
              <a href="#about" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a>
              <a href="#app" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">客户端入口</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-800 mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-300/30 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2024-2026 暗网吃瓜. All rights reserved.
          </p>
          <p className="text-xs text-foreground-500">
            本站所有内容均源自公开信息聚合与用户匿名投稿，不代表本站立场。吃瓜有度，理性讨论。
          </p>
        </div>
      </div>
    </footer>
  );
}